import React from 'react';
import './AdminGroups.css';
import OrganizationSettings from './OrganizationSettings';

export default function GroupsPage() {
  return <OrganizationSettings />;
}
